import { getPlaces } from "../../../app/api/getPlaces";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, StationsListType } from "../../../Orchestrator/Types/Index";
import { IPlaces } from "../../../Orchestrator/Types/Interface/IPlaces";
import { LocationPermission } from "../../../Orchestrator/Types/Types/FmlmSearch/FmlmSearchType";
import { distanceCalculate } from "../../LogicActions/FmlmSearch/FmlmDistanceService";

export class UpdatedFmlmStopsAction extends BaseAction<
  void,
  { data: StationsListType; locationPermission: LocationPermission }
> {
  
  async enrichStopsWithDistance(stopList: StationsListType, places: IPlaces[], locationPermission: LocationPermission): Promise<StationsListType> {
    if (!(locationPermission.isGranted && locationPermission.position)) {
      return Promise.resolve(stopList);
    }

    const startLngLat: [number, number] = [
      locationPermission.position.coords.longitude,
      locationPermission.position.coords.latitude,
    ];
    // let startLngLat: [number, number] = [54.3773, 24.4539]; // Default coordinates for Abu Dhabi

    let placesMap: Map<string, IPlaces> = new Map();
    places.forEach((place) => placesMap.set(place.id.toString(), place));

    let stopGeoPointsMap: Map<string, {
      coordinates: [number, number],
      distanceFromCurrent?: number
    }> = new Map();
    stopList.map((stop) => {
      stop.subStations.forEach((subStation) => {
        let stopGeoPosition = placesMap.get(subStation.id!.toString())?.geoPosition || null;

        if (stopGeoPosition) {
          stopGeoPointsMap.set(subStation.id!, {
            coordinates: [stopGeoPosition.longitude, stopGeoPosition.latitude]
          });
        }
      });

      const stopGeoPosition = placesMap.get(stop.id!.toString())?.geoPosition || null;
      if (stopGeoPosition) {
        stopGeoPointsMap.set(stop.id, {
          coordinates: [stopGeoPosition.longitude, stopGeoPosition.latitude]
        });
      }
    });

    let stopDistance: number[];
    stopDistance = await distanceCalculate(startLngLat, Array.from(stopGeoPointsMap.values()).map((value) => value.coordinates));

    const keys = Array.from(stopGeoPointsMap.keys());
    stopGeoPointsMap.forEach((value, key) => {
      const index = keys.indexOf(key);
      if (index !== -1 && stopDistance[index] !== undefined) {
        value.distanceFromCurrent = stopDistance[index];
      }
    });

    const enrichedStopList = stopList.map((stop) => {
      let newStop = { ...stop };
      newStop.subStations = stop.subStations.map((subStation) => {
        const stopGeoPoint = stopGeoPointsMap.get(subStation.id!);
        if (stopGeoPoint) {
          return ({
            ...subStation,
            geoPosition: {
              lat: stopGeoPoint.coordinates[1],
              lng: stopGeoPoint.coordinates[0],
            },
            distanceFromCurrent: stopGeoPoint.distanceFromCurrent || 0,
          });
        }
        return subStation;
      });

      const stopGeoPoint = stopGeoPointsMap.get(stop.id);
      if (stopGeoPoint) {
        newStop.geoPosition = {
          lat: stopGeoPoint.coordinates[1],
          lng: stopGeoPoint.coordinates[0],
        };
        newStop.distanceFromCurrent = stopGeoPoint.distanceFromCurrent || 0;
      }

      return newStop;
    });

    return Promise.resolve(enrichedStopList);
  }

  override async run(): Promise<void | null> {
    try {
      const { data: stopList, locationPermission } = this.params!;

      const response = await getPlaces();
      if (response.status !== "ok" || !response.answer) return;

      const places = response.answer?.places;

      let enrichedStopList = await this.enrichStopsWithDistance(stopList, places, locationPermission);

      updateRecoilState("updatedStopsAtom", enrichedStopList);
    } catch (error) {
      console.error("Error in UpdatedStopsAction:", error);
    }
  }
}

// Create a singleton instance
export const updatedFmlmStopAction = new UpdatedFmlmStopsAction();
